import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';
import { getRandomID } from '@kite_aerolab/shared/utils';

@Directive({
  selector: '[kiteTextarea]',
  providers: [NgModel],
})
export class TextareaDirective implements AfterViewInit {
  value = '';
  focus = false;

  constructor(public el: ElementRef, public control: NgModel) {}

  ngAfterViewInit() {
    if (!this.el.nativeElement.id) {
      this.el.nativeElement.id = getRandomID();
    }
  }

  getID() {
    return this.el.nativeElement.id;
  }

  clear() {
    this.el.nativeElement.value = '';
    this.value = '';
  }

  isInvalid() {
    return this.control.invalid;
  }

  isValid() {
    return this.control.valid;
  }

  isDisabled() {
    return this.el.nativeElement.disabled;
  }

  isRequired() {
    return this.el.nativeElement.required;
  }

  @HostListener('focus')
  onFocus() {
    this.focus = true;
  }

  @HostListener('blur')
  onBlur() {
    this.focus = false;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.value = value;
  }
}
